<div class="row">
  <div class="col">
    <app-file-upload
      [header]="header"
      [width]="width"
      [height]="height"
      [image]="true"
      [largeHeader]="largeHeader"
      [showRemove]="showRemove"
      [showBrowse]="showBrowse"
      [src]="image2 ? product?.imagePath2 : product?.imagePath"
      (save)="save($event)"
      (remove)="remove()"
    >
    </app-file-upload>
  </div>
</div>
